import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import identity from 'lodash/identity';
import { Controller, get, useFormContext } from 'react-hook-form';

import { ToggleButtonGroup } from '@src/components/ToggleButtonGroup';
import { Label, Text } from '@src/components/Typography';
import { VStack } from '@src/components/VStack';
import { ToggleButtonGroupFieldProps } from './interface';

export const ToggleButtonGroupField = (props: ToggleButtonGroupFieldProps) => {
  const {
    formatOnChange = identity,
    label,
    name,
    options,
    parseValue = identity,
  } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const fieldErrors = get(errors, name);

  const parsedErrors = fieldErrors ? { [name]: fieldErrors } : {};

  const hasErrors = !!parsedErrors[name];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value: fieldValue } }) => (
        <VStack>
          <Label size="s">{label}</Label>
          <ToggleButtonGroup
            color={hasErrors ? 'error' : 'default'}
            options={options}
            selected={options.find((opt) => parseValue(fieldValue) === opt.value) || null}
            onSelect={(selectedOption) => {
              const val = selectedOption.value;
              const newVal = formatOnChange(val, fieldValue);
              onChange(newVal);
            }}
            size="medium"
          />
          <ErrorMessage
            name={name}
            errors={parsedErrors}
            render={({ message }) => (
              <Text size="s" color="state.error.secondary">
                {message}
              </Text>
            )}
          />
        </VStack>
      )}
    />
  );
};
